
// import React, { useEffect } from "react";
import React, { useEffect } from "react";

import { Routes, Route, useLocation } from "react-router-dom";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

import Vehicles from "./admin/ListeVoitures";
import Login from "./auth/Login";
import RequireAuth from "./auth/RequireAuth";
import MarquesModeles from "./admin/MarquesModeles";
import LocationManager from "./admin/LocationManager";
import AdminReservations from "./admin/AdminReservations";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import ListeMarques from "./pages/ListeMarques";
import ListeModelesParMarque from "./pages/ListeModelesParMarque";
import VehicleDetail from "./pages/VehicleDetail";
import CataloguePage from "./pages/CataloguePage"; // ← 🆕 Nouvelle page catalogue
import AboutPage from "./pages/AboutPage";
import ScrollResetter from "./components/ScrollResetter";
import "./App.css";
import MarqueDetails from "./pages/MarqueDetails";
// Dans App.js ou le fichier principal
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import LoginRegister from "./pages/LoginRegister";
import Favoris from "./pages/Favoris";
import Profil from "./pages/Profil";
import AdminMiseAJourMarqueId from "./pages/AdminMiseAJourMarqueId";
import SearchLocationForm from "./pages/SearchLocationForm";
import useVisitorTracker from "./hooks/useVisitorTracker"; // si extrait dans un fichier
import LocationVehicules from "./pages/LocationVehicules";
import Reservation from "./pages/Reservation";
import ReservationDetails from "./pages/ReservationDetails";
import Navette from "./pages/Navette"; // adapte le chemin selon ton arborescence
import VideoUploader from "./admin/VideoUploader";
import AdminFeaturedChoices from "./admin/AdminFeaturedChoices";
import AdminDashboard from "./admin/AdminDashboard";
import AdminPieces from "./admin/AdminPieces";
import PiecesDetacheesPage from "./pages/PiecesDetacheesPage";
import PieceDetailsPage from "./pages/PieceDetailsPage";
import MaintenanceRendezvous from "./pages/MaintenanceRendezvous";
import AdminMaintenance from "./admin/AdminMaintenance";

export default function App() {
  useEffect(() => {
    const auth = getAuth();
    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        //console.log("✅ Persistance Firebase activée (localStorage)");
      })
      .catch((error) => {
        //console.error("Erreur de persistance Firebase :", error);
      });
  }, []);
  const location = useLocation();
  useVisitorTracker(location.pathname); // ✅ Appel correct
  return (
    <>
      <ScrollResetter /> {/* ← nettoyage global à chaque navigation */}

      <Routes>
        {/* Pages publiques */}
        <Route path="/" element={<Home />} />
        <Route path="/marques" element={<ListeMarques />} />
        <Route path="/vehicules/:slug" element={<VehicleDetail />} />
        <Route path="/a-propos" element={<AboutPage />} />
        <Route path="/catalogue" element={<CataloguePage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/locations" element={<LocationVehicules />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/reservation/details/:id" element={<ReservationDetails />} />
        <Route path="/navette" element={<Navette />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Identity/Account/Login" element={<LoginRegister mode="login" />} />
        <Route path="/Registration" element={<LoginRegister mode="register" />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="/Vehiclelisting/:slug" element={<MarqueDetails />} />
        <Route path="/marques/:marqueId/modeles" element={<ListeModelesParMarque />} />
        <Route path="/admin/mise-a-jour-marqueid" element={<AdminMiseAJourMarqueId />} />
        {/* <Route path="/locations" element={<Location />} /> */}
        <Route path="/SearchLocationForm" element={<SearchLocationForm />} />
        <Route path="/admin/pieces" element={<RequireAuth><AdminPieces /></RequireAuth>} />
        <Route path="/pieces-detachees" element={<PiecesDetacheesPage />} />
        <Route path="/piece/:slug" element={<PieceDetailsPage />} />
        <Route path="/maintenance-rendezvous" element={<MaintenanceRendezvous />} />
        <Route path="/admin/maintenance" element={<RequireAuth><AdminMaintenance /></RequireAuth>} />
        {/* Routes d'administration */}
        <Route
          path="/admin/vehicles"
          element={
            <RequireAuth>
              <Vehicles />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/LocationManager"
          element={
            <RequireAuth>
              <LocationManager />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/reservations"
          element={
            <RequireAuth>
              <AdminReservations />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/marques"
          element={
            <RequireAuth>
              <MarquesModeles />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/VideoUploader"
          element={
            <RequireAuth>
              <VideoUploader />
            </RequireAuth>
          }
        />
          <Route path="/admin/featured-choices" element={<RequireAuth><AdminFeaturedChoices /> </RequireAuth>} />
          <Route path="/dashboard" element={<RequireAuth><AdminDashboard /> </RequireAuth>} />
        <Route
          path="/favoris"
          element={
            <RequireAuth>
              <Favoris />
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );

}


